// DO NOT EDIT -- generated from fs/services/webber/internal/conversions/conversions.proto

import * as alexa from '../../../alexa';

export namespace ConversionsPublic {

  export const ComputeDimensionsForGuestSnapshotEndpoint = "/grpc/conversions.ConversionsPublic/ComputeDimensionsForGuestSnapshot";
  /** compute dimensions for snapshots. */
  export function ComputeDimensionsForGuestSnapshot(sender: (req: alexa.ComputeDimensionsRequest, endpoint: string) => Promise<alexa.ComputeDimensionsResponse>, req: alexa.ComputeDimensionsRequest): { promise: () => Promise<alexa.ComputeDimensionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeDimensionsForGuestSnapshotEndpoint),
      endpoint: ComputeDimensionsForGuestSnapshotEndpoint
    };
  }
}
